import Button from "components/Button";
import { useArrangementActions } from "./ArrangementContext";
import { STEP_ROUTES } from "./constants";

export default function BackToReviewButton() {
  const { goToStep } = useArrangementActions();

  return (
    <div className="mt-8 text-center">
      <Button
        variant="outline"
        onClick={() => goToStep(STEP_ROUTES.indexOf("confirmation"))}
      >
        Back to Review
      </Button>
    </div>
  );
}
